// This enum represents the different types of ad sources for milestones

const GOOGLE_ADS = 'GOOGLE_ADS' as const;
const FACEBOOK = 'FACEBOOK' as const;

const VALUES = [GOOGLE_ADS, FACEBOOK];

export type MilestoneAdKindType = (typeof VALUES)[number];

const VALUE_TO_LABEL = {
  [GOOGLE_ADS]: 'Google Ads',
  [FACEBOOK]: 'Facebook',
};

const getLabel = (adKind?: MilestoneAdKindType): string => {
  if (!adKind) return 'None';

  // Handle known ad kinds
  if (VALUE_TO_LABEL[adKind]) {
    return VALUE_TO_LABEL[adKind];
  }

  // Fallback formatting for unknown ad kinds
  return adKind
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const MilestoneAdKind = {
  GOOGLE_ADS,
  FACEBOOK,

  VALUES,
  getLabel,
};

export default MilestoneAdKind;
